import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { buttonVariants } from 'components/ui/button';
import { PATH_ROUTES } from 'routes/path';
import { Separator } from 'components/ui/separator';
import OTPLoginForm from './OTPLoginForm';
import PasswordLoginForm from './PasswordLoginForm';

export default function LoginPage() {
  const { t } = useTranslation();

  const [isOtpSignin, setIsOtpSignin] = useState<boolean>(false);

  const onSigninChange = () => setIsOtpSignin(!isOtpSignin);

  return (
    <div className='flex flex-col items-center w-full py-8 space-y-10 bg-white rounded-md'>
      <h2 className='text-2xl font-semibold tracking-tight transition-colors lg:text-3xl text-primary scroll-m-20'>
        {t('welcome_back')}
      </h2>

      {isOtpSignin ? (
        <OTPLoginForm onSigninChange={onSigninChange} />
      ) : (
        <PasswordLoginForm onSigninChange={onSigninChange} />
      )}

      <div className='flex flex-col items-center justify-center'>
        <div className='flex items-center gap-x-2'>
          <a
            href={process.env.REACT_APP_MEDSI_TOC}
            target='_blank'
            rel='noopener noreferrer'
            className={buttonVariants({
              variant: 'link',
              className: 'cursor-pointer',
            })}
          >
            {t('tnc')}
          </a>
          <Separator orientation='vertical' className='h-4' />
          <a
            href={process.env.REACT_APP_MEDSI_PRIVACY}
            target='_blank'
            rel='noopener noreferrer'
            className={buttonVariants({
              variant: 'link',
              className: 'cursor-pointer',
            })}
          >
            {t('pp')}
          </a>
        </div>

        <div>
          <span className='font-medium'>{t('no_acount')}</span>{' '}
          <Link
            to={PATH_ROUTES.SIGNUP}
            className={buttonVariants({ variant: 'link' })}
          >
            {t('sign_up')}
          </Link>
        </div>
      </div>
    </div>
  );
}
